import React from 'react';
import ScenarioPhotoLightbox from '../components/ScenarioPhotoLightbox';
import { useScenarioLegPhotos, type ScenarioLegPhotoTarget } from '../hooks/useScenarioLegPhotos';

/**
 * The lightbox, fed by one leg's one capture phase.
 *
 * The fetcher shape at its smallest: acquire (the on-open photo query, gated so the other
 * phase never downloads), map (the portal's carousel pipeline, private-step filter
 * included), and render the entry. The viewer itself stays pure — it never learns where
 * its images came from.
 */
export interface ScenarioPhotoLightboxByLegPhaseProps {
  /** What to show, or null for closed. Doubles as the viewer's session key. */
  target: ScenarioLegPhotoTarget | null;
  onClose: () => void;
}

const ScenarioPhotoLightboxByLegPhase: React.FC<ScenarioPhotoLightboxByLegPhaseProps> = ({
  target,
  onClose,
}) => {
  const { images } = useScenarioLegPhotos(target);

  return (
    <ScenarioPhotoLightbox
      sessionKey={target ? `${target.moveId}:${target.phase}` : null}
      images={images}
      onClose={onClose}
    />
  );
};

export default ScenarioPhotoLightboxByLegPhase;
